<template>
    <login-panel :back-route-name="backRoute" class="answer-secret-question" xs>
      <div role="form" class="answer-secret-question__content">
        <div class="answer-secret-question__icon">
          <img src="/static/imgs/question-circle-green.png" alt="">
        </div>
        <h3 class="answer-secret-question__title">
          {{ $t('login.secret-question') }}
        </h3>
        <p v-if="recoverData" class="answer-secret-question__question">
          {{ recoverData.secretQuestion }}
        </p>
        <label for="answer" class="answer-secret-question__label">
          {{ $t('login.answer') }}
        </label>
        <b-form-input
          id="answer"
          type="text"
          v-model="answer"
          :state="$bsStateValidator($v.answer.$error)"
          @input="$v.answer.$touch()"
          maxlength="100"
        ></b-form-input>
        <div class="form-row answer-secret-question__captcha">
          <captcha ref="captcha" v-if="showCaptcha"/>
        </div>
        <div class="form-row answer-secret-question__form-row">
          <b-button
            class="answer-secret-question__btn-send"
            @click="replySecretQuestion"
            variant="primary"
            :disabled="$v.$invalid"
            block
          >
            {{ $t('login.send') }}
          </b-button>
        </div>
      </div>
    </login-panel>
</template>


<script>
import { mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import Captcha from '@/components/captcha/Captcha';
import commonCaptchaService from '@/services/security/common';
import LoginPanel from '@/components/LoginPanel';
import PasswordRecoverService from '@/domain/services/login/passwordRecoverService';

export default {
  components: {
    LoginPanel,
    Captcha,
  },
  props: {},
  data() {
    return {
      answer: null,
      showCaptcha: false,
    };
  },
  validations: {
    answer: {
      required,
    },
  },
  computed: {
    ...mapGetters([
      'isOffLineMode',
      'recoverData',
    ]),
    backRoute() {
      return this.isOffLineMode ? 'insert-user-data' : 'retrieve-options';
    },
  },
  created() {
    if (!this.recoverData) {
      this.$router.push({
        name: 'insert-user-data',
      });
    }
  },
  methods: {
    replySecretQuestion() {
      if (this.showCaptcha) {
        const { captcha } = this.$refs;
        captcha.validateCaptcha()
          .then(() => {
            this.send();
          })
          .catch(() => {
            captcha.getCaptcha();
          });
      } else {
        this.send();
      }
    },
    send() {
      PasswordRecoverService.validateSecretAnswer(this.answer,
        this.recoverData.username,
        this.recoverData.email)
        .then((temporaryPassword) => {
          this.$router.push({
            name: 'temporary-password',
            params: temporaryPassword,
          });
        }).catch((error) => {
          if (!!error.response && error.response.status === 400) {
            this.showOrHideCaptcha(error);
          }
        });
    },
    showOrHideCaptcha(error) {
      const errorData = commonCaptchaService.extractErrorInformation(error);

      if (commonCaptchaService.shouldShowCaptcha(errorData.blockedUser,
        errorData.wrongAttempts)) {
        if (this.showCaptcha) {
          this.$refs.captcha.getCaptcha();
        }
        this.showCaptcha = true;
      } else {
        this.showCaptcha = false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/mixins"

  .answer-secret-question
    display: flex
    flex-direction: column
    +md-box-shadow-3
    &__form-row
      margin-top: 5px
      display: flex
      flex-direction: column
    &__captcha
      margin-top: 20px
      display: flex
      flex-direction: column
      align-items: center
    &__content
      display: flex
      flex-direction: column
    &__icon
      min-height: 80px
      max-height: 80px
      display: flex
      justify-content: center
      margin-bottom: 30px
      img
        height: 80px
        flex-shrink: 0
    &__title
      text-align: center
      font-weight: 600
      text-transform: uppercase
      font-size: 1.1rem
      margin-bottom: 30px
    &__question
      font-weight: 600
      font-size: 1.05rem
    &__btn-send
      margin-top: 20px
</style>
